
const guidRegex = /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/;

/**
 * Check if input string match guid format. 
 */
export function isGuid(guid: string): boolean {
	return guid?.length && guidRegex.test(guid);
}